/*
 * Author: Dw
 * File Created: Monday, 24-07-22 06:15 pm
 * Last Modified: Tuesday, 24-11-19 04:31 pm, by Roger
 */

import { Box, selectClasses, Step, stepClasses, stepConnectorClasses, stepIconClasses, StepIconProps, stepLabelClasses, Stepper } from '@mui/material';
import { ComponentsOverrides, ComponentsProps, ComponentsVariants, styled, Theme } from '@mui/material/styles';
import { Icon } from '@/Icon';
interface CustomStepIconRootProps {
  active: boolean;
  completed: boolean;
}
const CustomStepIconRoot = styled('div')<CustomStepIconRootProps>(({
  theme,
  active,
  completed
}) => ({
  backgroundColor: completed ? 'transparent' : active ? '#fff' : '#707A8A',
  color: theme.palette.background.default,
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center'
}));
export const CustomStepIcon: React.FC<StepIconProps> = props => {
  const {
    active,
    completed,
    icon,
    className
  } = props;
  return <CustomStepIconRoot active={!!active} completed={!!completed} className={className} data-sentry-element="CustomStepIconRoot" data-sentry-component="CustomStepIcon" data-sentry-source-file="stepper.tsx">
      {completed ? <Icon name="CheckCircleIcon" sx={{
      color: '#FFF',
      width: '28px',
      height: '28px'
    }} /> : <Box sx={{
      fontSize: '14px'
    }}>{icon}</Box>}
    </CustomStepIconRoot>;
};

// 自定义 Stepper 样式
type StepperThemeOptions = {
  defaultProps?: ComponentsProps['MuiStepper'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiStepper'];
  variants?: ComponentsVariants<Theme>['MuiStepper'];
};
export const MuiStepper: StepperThemeOptions = {
  styleOverrides: {
    root: {
      padding: '16px 0 32px 0',
      backgroundColor: 'transparent',
      // 自定义背景色
      [`& .${stepClasses.alternativeLabel}`]: {
        padding: 0
        // 'max-width': '40px',
      },
      '.MuiStepLabel-iconContainer': {
        paddingLeft: '8px',
        paddingRight: '8px'
      }
    },
    alternativeLabel: {
      justifyContent: 'space-between' // 两端对齐
    }
  }
};
type StepConnectorThemeOptions = {
  defaultProps?: ComponentsProps['MuiStepConnector'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiStepConnector'];
  variants?: ComponentsVariants<Theme>['MuiStepConnector'];
};
export const MuiStepConnector: StepConnectorThemeOptions = {
  styleOverrides: {
    root: {
      '&.Mui-active': {
        [`& .${stepConnectorClasses.line}`]: {
          borderColor: '#FFF'
        }
      },
      '&.Mui-completed': {
        [`& .${stepConnectorClasses.line}`]: {
          borderColor: '#FFF'
        }
      }
    },
    line: {
      borderColor: '#707A8A',
      borderTopWidth: 2,
      borderBottomWidth: 5
      // borderRadius: 1,
    }
  }
};
type StepIconThemeOptions = {
  defaultProps?: ComponentsProps['MuiStepIcon'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiStepIcon'];
  variants?: ComponentsVariants<Theme>['MuiStepIcon'];
};
export const MuiStepIcon: StepIconThemeOptions = {
  defaultProps: {
    // @ts-ignore
    icon: CustomStepIcon
  }
};
type StepLabelThemeOptions = {
  defaultProps?: ComponentsProps['MuiStepLabel'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiStepLabel'];
  variants?: ComponentsVariants<Theme>['MuiStepLabel'];
};
export const MuiStepLabel: StepLabelThemeOptions = {
  styleOverrides: {
    label: {
      [`&.${stepLabelClasses.alternativeLabel}`]: {
        marginTop: 5
      },
      position: 'absolute',
      left: '50%',
      transform: `translate(-50%, 0)`,
      width: '60px',
      textAlign: 'center',
      bottom: '-20px',
      color: '#707A8A',
      fontSize: '12px',
      '&.Mui-active': {
        color: '#fff'
        // boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
      '&.Mui-completed': {
        color: '#fff'
      }
    }
  }
};